var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('z-dialogo',{ref:"dialogo",attrs:{"titulo":"Configurações","largura":"1360px","altura":"700px","background-color":"grey lighten-4","dividers":"","scrollable":"","hide-actions":""},scopedSlots:_vm._u([{key:"conteudo",fn:function(){return [_c(_setup.ConfiguracoesSistema)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }